<template>
  <v-container
    :fluid="!authUser"
    class="pt-8 px-8"
    style="width: 1000px"
    :style="{
      'background-color': 'white',
      'padding-left': authUser ? '48px' : '40px',
    }"
  >
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <v-dialog v-model="dialogLoader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="my-0 py-2">
          Espere un momento...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">
          Forma de Pago
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2">
          Ingreso de Datos
        </v-stepper-step>
        <!-- <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3">
          Validación de Datos
        </v-stepper-step> -->
      </v-stepper-header>

      <v-stepper-items>
        <!-- FORMA PAGO -->
        <v-stepper-content step="1">
          <v-card class="mb-0" elevation="0">
            <v-card outlined class="mb-4">
              <v-card-title class="subtitle-2">
                Selección de Forma de Pago
              </v-card-title>

              <v-card-text class="py-0">
                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <v-select
                      v-model="selectedFormaPago"
                      :items="formaPago"
                      label="Tipo"
                      dense
                      outlined
                      :readonly="esVistaPrevia"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text
                v-if="selectedFormaPago == 'Efectivo'"
                class="py-0 mb-3"
              >
                <small
                  >* Sí, realizará su pago en efectivo. Dar clic en siguiente
                </small>
              </v-card-text>
            </v-card>

            <v-card
              outlined
              class="mb-4"
              v-if="selectedFormaPago == 'Transferencia'"
            >
              <v-card-title class="subtitle-2 pt-4 pb-0">
                Cuenta Bancaria
              </v-card-title>
              <v-card-text class="py-0">
                <v-row class="py-0">
                  <v-col>
                    Todas las opciones son cuentas corrientes. Seleccione según
                    el banco:
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <v-select
                      v-model="selectedCuentaBancaria"
                      :items="cuentasBancarias"
                      label="Lista de Bancos"
                      dense
                      outlined
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6" class="py-1">
                    <v-text-field
                      label="Número de Cuenta"
                      v-model="numeroCuenta"
                      readonly
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="px-4 pb-3">
                  <small
                    >* Luego de copiar el número de cuenta, debe de dar click en
                    siguiente
                  </small>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card-actions>
              <v-row class="px-6">
                <v-spacer></v-spacer>
                <v-col cols="12" md="2">
                  <v-btn color="primary" @click="step = 2"> Siguiente </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!-- DATOS FACTURA -->
        <v-stepper-content step="2">
          <v-card class="mb-12" elevation="0">
            <v-card outlined class="mb-4 py-0">
              <v-card-title class="subtitle-2">
                Selección de Tipo Documento
              </v-card-title>
              <v-card-text>
                <v-row class="py-0">
                  <v-col cols="12" md="6" class="py-0">
                    <v-select
                      v-model="selectedTipoFactura"
                      :items="tipoFacturas"
                      label="Tipo de Documento"
                      item-value="tipoServicioConexionId"
                      item-text="nombre"
                      dense
                      :readonly="esVistaPrevia"
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Tarjeta de Documentos -->
            <v-form ref="filesForm">
              <v-card outlined class="mb-4">
                <v-card-title class="subtitle-2">
                  {{
                    esVistaPrevia ? "Archivos Adjuntos" : "Adjuntar Archivos"
                  }}
                </v-card-title>
                <v-card-text>
                  <v-row class="py-0">
                    <v-col cols="12" class="py-0">
                      <h1 class="subtitle-2">DUI</h1>
                      <v-divider class="mt-1 mb-2"></v-divider>
                      <file-uploader-conexion
                        v-if="
                          !esVistaPrevia ||
                          !archivosSubidosIDs.some((as) => as.ruta == 'DUI')
                        "
                        v-model="filesDUI"
                        label="Documento Único de Identidad (DUI)"
                      />
                      <MiniGalleryConexion
                        :mostrar="esVistaPrevia"
                        :vistas="vistasPreviaDUI"
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <h1 class="subtitle-2">NIT</h1>
                      <v-divider class="mt-1 mb-2"></v-divider>
                      <file-uploader-conexion
                        v-if="
                          !esVistaPrevia ||
                          !archivosSubidosIDs.some((as) => as.ruta == 'NIT')
                        "
                        v-model="filesNIT"
                        label="Número de Identificación Tributaria (NIT)"
                      />
                      <MiniGalleryConexion
                        :mostrar="esVistaPrevia"
                        :vistas="vistasPreviaNIT"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="selectedTipoFactura == 2"
                      class="py-0"
                    >
                      <h1 class="subtitle-2">TARJETA IVA</h1>
                      <v-divider class="mt-1 mb-2"></v-divider>
                      <file-uploader-conexion
                        v-if="
                          !esVistaPrevia ||
                          !archivosSubidosIDs.some((as) => as.ruta == 'IVA')
                        "
                        v-model="filesIVA"
                        label="Tarjeta de IVA"
                      />
                      <MiniGalleryConexion
                        :mostrar="esVistaPrevia"
                        :vistas="vistasPreviaIVA"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="py-0"
                      v-if="selectedFormaPago == 'Transferencia'"
                    >
                      <h1 class="subtitle-2">COMPROBANTE</h1>
                      <v-divider class="mt-1 mb-2"></v-divider>
                      <v-file-input
                        v-if="
                          !esVistaPrevia ||
                          !archivosSubidosIDs.some(
                            (as) => as.ruta == 'Comprobante'
                          )
                        "
                        v-model="filesComprobante"
                        accept="image/*"
                        label="Comprobante de Pago"
                        outlined
                        :rules="requiredFile"
                        dense
                        small-chips
                      ></v-file-input>
                      <MiniGalleryConexion
                        :mostrar="esVistaPrevia"
                        :vistas="vistasPreviaComprobante"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions
                  v-if="!esVistaPrevia || faltanVistasPrevia"
                  class="py-0 mb-2"
                >
                  <v-spacer></v-spacer>
                  <div class="d-flex justify-space-between px-4">
                    <v-btn @click="validacionArchivos" depressed color="primary"
                      >Subir Archivos</v-btn
                    >
                  </div>
                </v-card-actions>
              </v-card>
            </v-form>

            <!-- Tarjeta de Contacto -->
            <v-form ref="contactForm" v-if="selectedTipoFactura != 3">
              <v-card outlined class="mb-4">
                <v-card-title class="subtitle-2">
                  Información de Contacto
                </v-card-title>
                <v-card-text>
                  <v-row class="py-0">
                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="telefono"
                        label="Teléfono"
                        outlined
                        v-mask="'####-####'"
                        dense
                        :rules="requiredField"
                        :readonly="readOnly"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="correo"
                        label="Correo Electrónico"
                        outlined
                        dense
                        hint="correo@mail.com"
                        type="email"
                        :rules="requiredField"
                        :readonly="readOnly"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="direccion"
                        label="Dirección"
                        outlined
                        dense
                        :rules="requiredField"
                        :readonly="readOnly"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-form>
          </v-card>

          <!-- Botones -->
          <div class="d-flex justify-space-between px-2">
            <v-btn @click="step--" color="primary" outlined> Regresar </v-btn>
            <v-btn
              color="primary"
              @click="guardar"
              depressed
              v-if="
                !readOnly &&
                archivosSubidosIDs.length > 0 &&
                selectedTipoFactura != 3
              "
            >
              Guardar
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import Axios from "axios";
import router from "../router";
import FileUploaderConexion from "./Minis/FileUploaderConexion.vue";
import MiniGalleryConexion from "./Minis/MiniGalleryConexion.vue";

export default {
  name: "ServiciosConexion",
  components: {
    FileUploaderConexion,
    MiniGalleryConexion,
  },
  data: () => ({
    step: 1,
    filesDUI: [],
    archivosSubidosIDs: [],
    vistasPrevia: [],
    filesComprobante: [],
    filesNIT: [],
    filesIVA: [],
    numeroAsistencia: null,
    requiredField: [(v) => !!v || "Campo Requerido"],
    requiredFile: [
      (v) => !!v || "Debe incluir un archivo",
      (v) => !v || v.size < 5000000 || "El archivo debe ser menor a 5MB",
      (v) =>
        !v ||
        (v &&
          v.type &&
          v.type.startsWith("image/" || v.type === "application/pdf")) ||
        "Solo se permiten imágenes o pdf",
    ],
    servicioConexion: {
      servicio: {},
      ruta: "",
    },
    dialogLoader: false,
    telefono: "",
    readOnly: false,
    rutaBaseDrive: "",
    direccion: "",
    correo: "",
    cuentasBancarias: ["BAC", "Banco Agrícola", "Banco Cuscatlán"],
    selectedCuentaBancaria: "BAC",
    formaPago: ["Transferencia", "Efectivo"],
    selectedFormaPago: "Transferencia",
    tipoFacturas: ["Consumidor Final", "Crédito Fiscal"],
    selectedTipoFactura: 1,
    snack: false,
    snackColor: "primary",
    snackTime: 4500,
    snackText: "",
  }),
  computed: {
    faltanVistasPrevia() {
      const vistas = ["DUI", "NIT", "IVA", "Comprobante"];
      let vistasSeleccionada = [];
      if (this.selectedFormaPago == "Transferencia") {
        switch (this.selectedTipoFactura) {
          case 1:
            vistasSeleccionada = vistas.filter((v) => v != "IVA");
            break;
          case 2:
            vistasSeleccionada = vistas;
            break;
          case 3:
            vistasSeleccionada = vistas.filter((v) => v != "IVA");
            break;
          default:
            vistasSeleccionada = [];
            break;
        }
      } else {
        switch (this.selectedTipoFactura) {
          case 1:
            vistasSeleccionada = ["DUI", "NIT"];
            break;
          case 2:
            vistasSeleccionada = vistas.filter((v) => v != "Comprobante");
            break;
          case 3:
            vistasSeleccionada = ["DUI", "NIT"];
            break;
          default:
            vistasSeleccionada = [];
            break;
        }
      }

      const faltanArchivos = vistasSeleccionada.filter(
        (vista) => !this.archivosSubidosIDs.some((a) => a.ruta == vista)
      );
      if (faltanArchivos.length > 0) return true;

      return false;
    },
    esVistaPrevia() {
      return this.archivosSubidosIDs.length > 0;
    },
    vistasPreviaDUI() {
      return this.vistasPrevia.filter((a) => a.ruta == "DUI");
    },
    vistasPreviaNIT() {
      return this.vistasPrevia.filter((a) => a.ruta == "NIT");
    },
    vistasPreviaIVA() {
      return this.vistasPrevia.filter((a) => a.ruta == "IVA");
    },
    vistasPreviaComprobante() {
      return this.vistasPrevia.filter((a) => a.ruta == "Comprobante");
    },
    authUser() {
      return !!this.$store.state.token;
    },
    numeroCuenta() {
      switch (this.selectedCuentaBancaria) {
        case "BAC":
          return "201251675";
          break;
        case "Banco Agrícola":
          return "5030486864";
          break;
        case "Banco Cuscatlán":
          return "012301000064106";
          break;

        default:
          return "-----------";
          break;
      }
    },
  },
  created() {
    this.numeroAsistencia = this.$route.params.asistencia;

    this.listarComboBox();
    this.getAsistencia(this.numeroAsistencia);
  },
  methods: {
    async getArchivosGuardados() {
      this.archivosSubidosIDs = [];
      const rutasCarpetas = ["DUI", "NIT", "COMPROBANTE", "IVA"];
      for (const ruta of rutasCarpetas) {
        const rutaDrive = `${this.rutaBaseDrive}/${ruta}`;

        await Axios.get("api/OneDrive?ruta=" + rutaDrive)
          .then((res) => {
            if (res.data.value) {
              let filteredResponse = res.data.value.map((f) => {
                return {
                  id: f.id,
                  ruta: f.parentReference.name,
                };
              });

              this.archivosSubidosIDs.push(...filteredResponse);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }

      this.dialogLoader = false;
      this.getVistaPrevia();
    },
    async getVistaPrevia() {
      if (this.archivosSubidosIDs.length === 0) return;

      this.vistasPrevia = [];

      try {
        const promises = this.archivosSubidosIDs.map(async (archivo) => {
          try {
            const res = await Axios.get(
              `api/OneDrive/VistaPrevia/${archivo.id}`
            );

            if (!res.data.error) {
              return {
                id: archivo.id,
                ruta: archivo.ruta,
                url: res.data.value[0].large.url,
              };
            }
          } catch (err) {
            console.error(`Error con archivo ${archivo.id}:`, err);
            return null;
          }
        });

        const resultados = await Promise.all(promises);
        this.vistasPrevia = resultados.filter((item) => item !== null);
      } catch (error) {
        console.error("Error general:", error);
      } finally {
        this.dialogLoader = false;
      }
    },
    listarComboBox() {
      Axios.get("api/TipoServicioConexion")
        .then((res) => {
          this.tipoFacturas = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAsistencia(numAsistencia) {
      this.dialogLoader = true;

      Axios.get(`/api/OneDrive/RutaArchivos/${numAsistencia}`)
        .then((res) => {
          this.servicioConexion = res.data;
          this.rutaBaseDrive = this.servicioConexion.ruta;

          if (this.servicioConexion.servicio) {
            if (
              this.servicioConexion.servicio.estado >= 3 &&
              !!this.$store.state.token == false
            ) {
              router.push({ name: "login" }).catch(() => {});
            }

            this.direccion = this.servicioConexion.servicio.direccion;
            this.telefono = this.servicioConexion.servicio.telefono;
            this.correo = this.servicioConexion.servicio.correo;
            this.selectedFormaPago = this.servicioConexion.servicio.formaPago;
            this.selectedTipoFactura =
              this.servicioConexion.servicio.tipoServicioConexionId;

            this.readOnly = this.servicioConexion.servicio.estado >= 3;
          } else {
            this.readOnly = false;
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          if (this.rutaBaseDrive != "") {
            this.getArchivosGuardados();
          }
        });
    },
    async subirArchivos() {
      try {
        const formData = new FormData();

        let requestIndex = 0;

        // Archivos DUI
        if (this.filesDUI.length > 0) {
          formData.append(`TipoArchivos[${requestIndex}].Ruta`, "DUI");
          this.filesDUI.forEach((archivo, archivoIndex) => {
            formData.append(`TipoArchivos[${requestIndex}].Archivos`, archivo);
          });
          requestIndex++;
        }

        // Archivos NIT
        if (this.filesNIT.length > 0) {
          formData.append(`TipoArchivos[${requestIndex}].Ruta`, "NIT");
          this.filesNIT.forEach((archivo, archivoIndex) => {
            console.log(archivo);
            formData.append(`TipoArchivos[${requestIndex}].Archivos`, archivo);
          });
          requestIndex++;
        }

        // Archivo Comprobante
        if (
          this.filesComprobante &&
          this.selectedFormaPago != "Efectivo" &&
          !this.esVistaPrevia
        ) {
          const helperComprobante = [this.filesComprobante];

          formData.append(`TipoArchivos[${requestIndex}].Ruta`, "Comprobante");
          helperComprobante.forEach((archivo, archivoIndex) => {
            formData.append(`TipoArchivos[${requestIndex}].Archivos`, archivo);
          });
          requestIndex++;
        }

        // Archivos IVA
        if (
          this.selectedTipoFactura == 2 &&
          this.filesIVA &&
          this.filesIVA.length > 0
        ) {
          formData.append(`TipoArchivos[${requestIndex}].Ruta`, "IVA");
          this.filesIVA.forEach((archivo, archivoIndex) => {
            formData.append(`TipoArchivos[${requestIndex}].Archivos`, archivo);
          });
          requestIndex++;
        }

        if (this.$refs.filesForm.validate()) {
          this.dialogLoader = true;
          const response = await Axios.post(
            `/api/OneDrive/${this.numeroAsistencia}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          this.dialogLoader = false;
          if (response.data) {
            this.snack = true;
            this.snackColor = "primary";
            this.snackText = "Archivos subidos exitosamente";

            if (this.faltanVistasPrevia && this.esVistaPrevia) {
              this.archivosSubidosIDs = [
                ...this.archivosSubidosIDs,
                ...response.data,
              ];
              return;
            }
            this.archivosSubidosIDs = response.data;
            this.crearServicioConexion();
          } else {
            this.dialogLoader = true;
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Error al subir el archivo";
          }
        } else {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Debe Adjuntar todos los Archivos";
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async validacionArchivos() {
      await this.subirArchivos();

      this.getVistaPrevia();
    },
    guardar() {
      this.actualizarServicioConexion();
    },
    crearServicioConexion() {
      const servicio = {
        numeroAsistencia: this.numeroAsistencia,
        telefono: this.telefono,
        direccion: this.direccion,
        correo: this.correo,
        tipoServicioConexionId: this.selectedTipoFactura,
        formaPago: this.selectedFormaPago,
      };

      Axios.post("api/ServiciosConexion", servicio)
        .then((res) => {
          this.snack = true;
          this.snackText = "Información guardada!";
          this.snackColor = "primary";

          this.readOnly = res.data.estado >= 3;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    actualizarServicioConexion() {
      const servicio = {
        numeroAsistencia: this.numeroAsistencia,
        telefono: this.telefono,
        direccion: this.direccion,
        correo: this.correo,
        tipoServicioConexionId: this.selectedTipoFactura,
        formaPago: this.selectedFormaPago,
      };

      if (this.$refs.contactForm.validate()) {
        Axios.put(`api/ServiciosConexion/${this.numeroAsistencia}`, servicio)
          .then((res) => {
            this.snack = true;
            this.snackText = "Información guardada!";
            this.snackColor = "primary";

            this.readOnly = res.data.estado >= 3;
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Debe completar toda la informacion requerida...";
      }
    },
  },
};
</script>

<style>
</style>